import { useCallback, useEffect, useMemo, useState } from "react";
import {
  GetNewsSearchesRequest,
  GetNewsSearchesResponse,
  NewsSearch,
} from "../models/newsModels";
import { usePost } from "./usePost";

type UseNewsSearchesResult = {
  searches: NewsSearch[];
  reload: () => void;
};

const SEARCH_LIMIT = 5;

export const useNewsSearches = (
  compassCids: string[] | null,
): UseNewsSearchesResult => {
  const [searches, setSearches] = useState<NewsSearch[]>([]);
  const [reloadCount, setReloadCount] = useState(0);
  const { sendData } = usePost<GetNewsSearchesResponse, GetNewsSearchesRequest>();
  const companyKey = compassCids?.join(",") ?? "";

  const request = useMemo<GetNewsSearchesRequest>(
    () => ({
      compass_cid: companyKey ? companyKey.split(",") : null,
      limit: SEARCH_LIMIT,
    }),
    [companyKey],
  );

  useEffect(() => {
    let isCurrent = true;
    sendData("GET_NEWS_SEARCHES", request).then((response) => {
      if (isCurrent && response) {
        setSearches(response.searches);
      }
    });
    return (): void => {
      isCurrent = false;
    };
  }, [sendData, request, reloadCount]);

  const reload = useCallback((): void => {
    setReloadCount((count) => count + 1);
  }, []);

  return { searches, reload };
};
